<template>
  <div class="height_100 p10">
    <div class="leads_search" v-if="questionWentiDialog">
      <div class="leads_search_box">
        <div class="newHuokequestion flex_item_satrt">
          <div class="newHuo_left">
            <div class="leads-content">
              <div class="leads-flex">
                <div class="leads-content-right">
                  <div class="leads-content-right-content">
                    <ul class="newHouke-ul margin-top10 margin-bottom30">
                      <li
                        class="newHouke-li"
                        v-for="(item, index) in 4"
                        :class="NewShowIndex >= index ? 'newShowActive' : ''"
                        :key="index"
                        @click="ActiceNewIndex(index)"
                      ></li>
                    </ul>
                    <div class="question_step_box">
                      <div
                        v-for="(item, index) in QuestionPageList"
                        :key="index"
                      >
                        <div
                          class="question-step-con"
                          v-if="
                            item.leadsQuestions?.pageNo == 1 &&
                            NewShowIndex == 0
                          "
                        >
                          <p class="question-step-question margin-bottom20">
                            <span
                              class="bitian"
                              v-if="item.leadsQuestions?.required == 1"
                              >*</span
                            >{{ item.leadsQuestions.questionContent }}
                          </p>

                          <div
                            v-if="
                              item.leadsQuestions.type == 2 && NewShowIndex == 0
                            "
                          >
                            <div class="NewHuokeradio">
                              <el-radio-group v-model="item.selectedCodes">
                                <el-radio
                                  v-for="ite in item.leadsOptions"
                                  :key="ite.optionsCode"
                                  border
                                  :class="
                                    item.selectedCodes?.optionsCode ==
                                    ite.optionsCode
                                      ? 'ActiveRedio'
                                      : ''
                                  "
                                  @change="leadsQuestionschange(ite)"
                                  :label="ite"
                                  ><span
                                    v-html="ite.optionsIcon"
                                    class="margin-right20"
                                  ></span>
                                  {{ ite.optionsContent }}</el-radio
                                >
                              </el-radio-group>
                            </div>
                          </div>
                        </div>
                        <div
                          class="question-step-con"
                          v-if="
                            item.leadsQuestions?.pageNo == 2 &&
                            NewShowIndex == 1
                          "
                        >
                          <p class="question-step-question margin-bottom20">
                            <span
                              class="bitian"
                              v-if="item.leadsQuestions?.required == 1"
                              >*</span
                            >{{ item.leadsQuestions.questionContent }}
                          </p>

                          <div
                            v-if="
                              item.leadsQuestions.type == 2 && NewShowIndex == 1
                            "
                          >
                            <div class="NewHuokeradio">
                              <el-radio-group v-model="item.selectedCodes">
                                <el-radio
                                  v-for="ite in item.leadsOptions"
                                  :key="ite.optionsCode"
                                  border
                                  :class="
                                    item.selectedCodes?.optionsCode ==
                                    ite.optionsCode
                                      ? 'ActiveRedio'
                                      : ''
                                  "
                                  @change="leadsQuestionschange(ite)"
                                  :label="ite"
                                >
                                  <span
                                    v-html="ite.optionsIcon"
                                    class="margin-right20"
                                  ></span>
                                  {{ ite.optionsContent }}</el-radio
                                >
                              </el-radio-group>
                            </div>
                          </div>
                        </div>

                        <div
                          class="question-step-con margin-bottom30"
                          v-if="
                            item.leadsQuestions?.pageNo == 3 &&
                            NewShowIndex == 2
                          "
                        >
                          <p class="question-step-question margin-bottom20">
                            <span
                              class="bitian"
                              v-if="item.leadsQuestions?.required == 1"
                              >*</span
                            >{{ item.leadsQuestions.questionContent }}
                          </p>
                          <div v-if="item.leadsQuestions.type == 2">
                            <el-select
                              :class="[
                                'wrap-placeholder-select',
                                !item.selectedCodes ? 'is-empty' : '',
                              ]"
                              :data-placeholder="item.leadsQuestions.defaultTips"
                              style="width: 100%"
                              clearable
                              value-key="optionsCode"
                              v-model="item.selectedCodes"
                              placeholder=""
                            >
                              <el-option
                                v-for="ite in item.leadsOptions"
                                :key="ite.optionsCode"
                                :label="ite.optionsContent"
                                :value="ite"
                              >
                              </el-option>
                            </el-select>
                          </div>
                          <div v-if="item.leadsQuestions.type == 3">
                            <el-select
                              :class="[
                                'wrap-placeholder-select',
                                !item.selectedCodes || item.selectedCodes.length === 0
                                  ? 'is-empty'
                                  : '',
                              ]"
                              :data-placeholder="item.leadsQuestions.defaultTips"
                              style="width: 100%"
                              clearable
                              filterable
                              value-key="optionsCode"
                              ref="upSelectduoxuan"
                              :multiple="true"
                              class="00in"
                              v-model="item.selectedCodes"
                              placeholder=""
                            >
                              <el-option
                                v-for="ite in item.leadsOptions"
                                :key="ite.optionsCode"
                                :label="ite.optionsContent"
                                :value="ite"
                              >
                              </el-option>
                            </el-select>
                          </div>
                          <div
                            v-if="
                              item.leadsQuestions.type == 8 &&
                              item.leadsQuestions.required == 1
                            "
                            style="position: relative"
                          >
                            <el-select
                              :class="[
                                'wrap-placeholder-select',
                                !item.selectedCodes ? 'is-empty' : '',
                              ]"
                              :data-placeholder="item.leadsQuestions.defaultTips"
                              filterable
                              style="width: 100%"
                              :loading="loading"
                              value-key="optionsCode"
                              loading-text=""
                              :no-data-text="''"
                              no-match-text=""
                              v-model="item.selectedCodes"
                              remote
                              :remote-method="debouncedRemoteMethod"
                              @focus="debouncedRemoteMethodfocus"
                              placeholder=""
                            >
                              <el-option
                                v-for="ite in item.leadsOptions"
                                :loading="loading"
                                :key="ite.id"
                                :value="ite"
                                :label="ite.optionsContent"
                              >
                                <el-tooltip
                                  :disabled="ite.optionsContent.length < 70"
                                  effect="light"
                                  :visible-arrow="false"
                                  :content="ite.optionsContent"
                                  placement="top"
                                >
                                  <div slot="content" style="max-width: 630px">
                                    {{ ite.optionsContent }}
                                  </div>
                                  <span
                                    style="
                                      display: block;
                                      max-width: 630px;
                                      line-height: auto;
                                    "
                                    class="Country_name"
                                    v-html="
                                      highlightKeyword(ite.optionsContent)
                                    "
                                  ></span>
                                </el-tooltip>
                              </el-option>
                            </el-select>
                            <i
                              style="cursor: pointer"
                              class="el-saech-eye el-input__icon el-icon-search"
                            ></i>
                          </div>
                          <div
                            v-if="item.leadsQuestions.type == 9"
                            style="position: relative"
                          >
                            <el-select
                              :class="[
                                'wrap-placeholder-select',
                                !item.selectedCodes || item.selectedCodes.length === 0
                                  ? 'is-empty'
                                  : '',
                              ]"
                              :data-placeholder="item.leadsQuestions.defaultTips"
                              filterable
                              :loading="loading"
                              style="width: 100%"
                              ref="upSelectduoxuanSearch"
                              value-key="aaa_id"
                              v-model="item.selectedCodes"
                              remote
                              :multiple="true"
                              :remote-method="
                                item.leadsQuestions.code == 6
                                  ? debouncedRemoteMethodCompany
                                  : debouncedRemoteMethodCompany3
                              "
                              placeholder=""
                            >
                              <el-option
                                v-for="ite in item.leadsOptions"
                                :key="ite.aaa_id"
                                :label="ite.optionsContent"
                                :value="ite"
                              >
                                <div
                                  style="max-width: 630px"
                                  class="flex_center_start_box Search_Company"
                                >
                                  <img class="Country_img" :src="ite.flag" />
                                  <el-tooltip
                                    :disabled="ite.optionsContent.length < 60"
                                    effect="light"
                                    :visible-arrow="false"
                                    :content="ite.optionsContent"
                                    placement="top"
                                  >
                                    <span class="Country_name">{{
                                      ite.optionsContent
                                    }}</span>
                                  </el-tooltip>
                                </div>
                              </el-option>
                            </el-select>
                            <i
                              class="el-saech-eye el-input__icon el-icon-search"
                            ></i>
                          </div>
                        </div>

                        <div
                          class="question-step-con margin-bottom30"
                          v-if="
                            item.leadsQuestions?.pageNo == 4 &&
                            NewShowIndex == 3 &&
                            item.leadsQuestions.required == 1
                          "
                        >
                          <p class="question-step-question margin-bottom20">
                            <span
                              class="bitian"
                              v-if="item.leadsQuestions?.required == 1"
                              >*</span
                            >{{ item.leadsQuestions.questionContent }}
                          </p>
                          <div v-if="item.leadsQuestions.type == 2">
                            <el-select
                              style="width: 100%"
                              clearable
                              value-key="optionsCode"
                              v-model="item.selectedCodes"
                              :placeholder="item.leadsQuestions.defaultTips"
                            >
                              <el-option
                                v-for="ite in item.leadsOptions"
                                :key="ite.optionsCode"
                                :label="ite.optionsContent"
                                :value="ite"
                              >
                              </el-option>
                            </el-select>
                          </div>
                          <div v-if="item.leadsQuestions.type == 3">
                            <el-select
                              style="width: 100%"
                              clearable
                              filterable
                              value-key="optionsCode"
                              ref="upSelectduoxuan"
                              :multiple="true"
                              v-model="item.selectedCodes"
                              :placeholder="item.leadsQuestions.defaultTips"
                            >
                              <el-option
                                v-for="ite in item.leadsOptions"
                                :key="ite.optionsCode"
                                :label="ite.optionsContent"
                                :value="ite"
                              >
                              </el-option>
                            </el-select>
                          </div>
                          <div
                            v-if="
                              item.leadsQuestions.type == 8 &&
                              item.leadsQuestions.required == 1
                            "
                            style="position: relative"
                          >
                            <el-select
                              filterable
                              style="width: 100%"
                              :loading="loading"
                              value-key="aaa_id"
                              loading-text=""
                              :no-data-text="''"
                              no-match-text=""
                              v-model="item.selectedCodes"
                              remote
                              :remote-method="debouncedRemoteMethod"
                              @focus="debouncedRemoteMethodfocus"
                              :placeholder="item.leadsQuestions.defaultTips"
                            >
                              <el-option
                                v-for="ite in item.leadsOptions"
                                :loading="loading"
                                :key="ite.id"
                                :label="ite.optionsContent"
                                :value="ite"
                              >
                                <el-tooltip
                                  :disabled="ite.optionsContent.length < 65"
                                  effect="light"
                                  :content="ite.optionsContent"
                                  :visible-arrow="false"
                                  placement="top"
                                >
                                  <span
                                    style="
                                      display: block;
                                      max-width: 630px;
                                      line-height: auto;
                                    "
                                    class="Country_name"
                                    v-html="
                                      highlightKeyword(ite.optionsContent)
                                    "
                                  ></span>
                                </el-tooltip>
                              </el-option>
                            </el-select>
                            <i
                              style="cursor: pointer"
                              class="el-saech-eye el-input__icon el-icon-search"
                            ></i>
                          </div>
                          <div
                            v-if="item.leadsQuestions.type == 9"
                            style="position: relative"
                          >
                            <el-select
                              filterable
                              :loading="loading"
                              style="width: 100%"
                              ref="upSelectduoxuanSearch"
                              value-key="aaa_id"
                              v-model="item.selectedCodes"
                              remote
                              :multiple="true"
                              :remote-method="
                                item.leadsQuestions.code == 6
                                  ? debouncedRemoteMethodCompany
                                  : debouncedRemoteMethodCompany3
                              "
                              :placeholder="item.leadsQuestions.defaultTips"
                            >
                              <el-option
                                v-for="ite in item.leadsOptions"
                                :key="ite.aaa_id"
                                :label="ite.optionsContent"
                                :value="ite"
                              >
                                <div
                                  style="max-width: 630px"
                                  class="flex_center_start_box Search_Company"
                                >
                                  <img class="Country_img" :src="ite.flag" />
                                  <el-tooltip
                                    :disabled="ite.optionsContent.length < 60"
                                    effect="light"
                                    :visible-arrow="false"
                                    :content="ite.optionsContent"
                                    placement="top"
                                  >
                                    <span class="Country_name">{{
                                      ite.optionsContent
                                    }}</span>
                                  </el-tooltip>
                                </div>
                              </el-option>
                            </el-select>
                            <i
                              class="el-saech-eye el-input__icon el-icon-search"
                            ></i>
                          </div>
                        </div>
                      </div>

                      <el-collapse
                        v-if="
                          QuestionPageList.filter(
                            (item) => item.leadsQuestions?.required == 2,
                          ).length > 0 && NewShowIndex == 3
                        "
                        v-model="activeNames"
                        @change="handleactiveNamesChange"
                      >
                        <el-collapse-item name="1" class="leads_opti_head">
                          <template slot="title">
                            <span class="el-collapse-hade">
                              Optional Questions
                            </span>
                          </template>
                          <div
                            v-for="(item, index) in QuestionPageList"
                            :key="index"
                          >
                            <div
                              class="question-step-con margin-bottom30"
                              v-if="
                                item.leadsQuestions?.pageNo == 4 &&
                                item.leadsQuestions?.required == 2
                              "
                            >
                              <p class="question-step-question margin-bottom20">
                                <span
                                  class="bitian"
                                  v-if="item.leadsQuestions?.required == 1"
                                  >*</span
                                >{{ item.leadsQuestions.questionContent }}
                              </p>
                              <el-input
                                v-if="item.leadsQuestions.type == 7"
                                id="ceb3e3"
                                v-model="item.selectedCodes"
                                :placeholder="item.leadsQuestions.defaultTips"
                              >
                              </el-input>
                              <div v-if="item.leadsQuestions.id == 11">
                                <el-cascader
                                  v-model="item.showCode"
                                  ref="cascader"
                                  filterable
                                  :props="cascaderProps"
                                  :options="item.leadsOptions"
                                  :placeholder="item.leadsQuestions.defaultTips"
                                  @change="handleChangetwo"
                                >
                                </el-cascader>
                              </div>
                              <div
                                v-if="
                                  item.leadsQuestions.type == 2 &&
                                  item.leadsQuestions.id != 11
                                "
                              >
                                <el-select
                                  style="width: 100%"
                                  ref="upSelectwo"
                                  value-key="optionsCode"
                                  filterable
                                  v-model="item.selectedCodes"
                                  :placeholder="item.leadsQuestions.defaultTips"
                                >
                                  <el-option
                                    v-for="ite in item.leadsOptions"
                                    :key="ite.optionsCode"
                                    :label="ite.optionsContent"
                                    :value="ite"
                                  >
                                  </el-option>
                                </el-select>
                              </div>
                              <div v-if="item.leadsQuestions.type == 3">
                                <el-select
                                  style="width: 100%"
                                  clearable
                                  value-key="optionsCode"
                                  ref="upSelectduoxuan"
                                  :multiple="true"
                                  v-model="item.selectedCodes"
                                  :placeholder="item.leadsQuestions.defaultTips"
                                >
                                  <el-option
                                    v-for="ite in item.leadsOptions"
                                    :key="ite.optionsCode"
                                    :label="ite.optionsContent"
                                    :value="ite"
                                  >
                                  </el-option>
                                </el-select>
                              </div>

                              <div v-if="item.leadsQuestions.type == 9">
                                <el-select
                                  filterable
                                  clearable
                                  :loading="loading"
                                  style="width: 100%"
                                  ref="upSelectduoxuanSearch"
                                  value-key="aaa_id"
                                  v-model="item.selectedCodes"
                                  remote
                                  :multiple="true"
                                  :remote-method="debouncedRemoteMethodCompany3"
                                  :placeholder="item.leadsQuestions.defaultTips"
                                >
                                  <template slot="prefix">
                                    <i
                                      class="el-input__icon el-icon-search"
                                    ></i>
                                  </template>
                                  <el-option
                                    v-for="ite in item.leadsOptions"
                                    :key="ite.aaa_id"
                                    :label="ite.company_name_en"
                                    :value="ite"
                                  >
                                    <div
                                      class="flex_center_start_box Search_Company"
                                    >
                                      <img
                                        class="Country_img"
                                        :src="ite.flag"
                                      /><span class="Country_name">{{
                                        ite.company_name_en
                                      }}</span>
                                    </div>
                                  </el-option>
                                </el-select>
                              </div>
                              <div v-if="item.leadsQuestions.type == 5">
                                <div style="display: flex" class="reaio-no">
                                  <el-radio
                                    border
                                    v-model="item.selectedOptions"
                                    label="Yes"
                                    >Yes</el-radio
                                  >
                                  <el-radio
                                    border
                                    class="margin-left20"
                                    v-model="item.selectedOptions"
                                    label="No"
                                    >No</el-radio
                                  >
                                </div>
                                <div>
                                  <el-input
                                    id="ceb3e3"
                                    v-model="item.selectedCodes"
                                    v-if="item.selectedOptions == 'Yes'"
                                    :placeholder="
                                      item.leadsQuestions.defaultTips
                                    "
                                    class="margin-top10"
                                  >
                                  </el-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="postion_bottom">
              <div class="flex_center" v-if="NewShowIndex == 0">
                <button
                  :disabled="
                    QuestionPageList.slice(
                      0,
                      QuestionPageList.filter(
                        (item) => item.leadsQuestions?.pageNo <= 1,
                      ).length,
                    ).filter(
                      (item) =>
                        item.selectedCodes == null ||
                        item.selectedCodes.length == 0,
                    ).length > 0
                  "
                  class="btn_exportyellow riskButton"
                  @click="NewShowIndex = NewShowIndex + 1"
                >
                  <span
                    v-if="
                      QuestionPageList.slice(
                        0,
                        QuestionPageList.filter(
                          (item) => item.leadsQuestions?.pageNo <= 1,
                        ).length,
                      ).filter(
                        (item) =>
                          item.selectedCodes == null ||
                          item.selectedCodes.length == 0,
                      ).length > 0
                    "
                    >Select all That Apply</span
                  ><span v-else>OK</span>
                </button>
              </div>
              <div class="flex_center" v-if="NewShowIndex == 1">
                <button
                  :disabled="
                    QuestionPageList.slice(
                      0,
                      QuestionPageList.filter(
                        (item) => item.leadsQuestions?.pageNo <= 2,
                      ).length,
                    ).filter(
                      (item) =>
                        item.selectedCodes == null ||
                        item.selectedCodes.length == 0,
                    ).length > 0
                  "
                  class="btn_exportyellow riskButton"
                  @click="NewShowIndex = NewShowIndex + 1"
                >
                  <span
                    v-if="
                      QuestionPageList.slice(
                        0,
                        QuestionPageList.filter(
                          (item) => item.leadsQuestions?.pageNo <= 2,
                        ).length,
                      ).filter(
                        (item) =>
                          item.selectedCodes == null ||
                          item.selectedCodes.length == 0,
                      ).length > 0
                    "
                    >Select all That Apply</span
                  ><span v-else>OK</span>
                </button>
              </div>
              <div class="flex_center" v-if="NewShowIndex == 2">
                <button
                  :disabled="
                    QuestionPageList.slice(
                      0,
                      QuestionPageList.filter(
                        (item) => item.leadsQuestions?.pageNo <= 3,
                      ).length,
                    ).filter(
                      (item) =>
                        item.selectedCodes == null ||
                        item.selectedCodes.length == 0,
                    ).length > 0
                  "
                  @click="NewShowIndex = NewShowIndex + 1"
                  class="btn_exportyellow riskButton"
                >
                  <span
                    v-if="
                      QuestionPageList.slice(
                        0,
                        QuestionPageList.filter(
                          (item) => item.leadsQuestions?.pageNo <= 3,
                        ).length,
                      ).filter(
                        (item) =>
                          item.selectedCodes == null ||
                          item.selectedCodes.length == 0,
                      ).length > 0
                    "
                    >Select all That Apply</span
                  ><span v-else>OK</span>
                </button>
              </div>
              <div class="flex_center" v-if="NewShowIndex == 3">
                <button
                  class="btn_exportyellow riskButton"
                  style="margin-right: 20px"
                  :disabled="
                    QuestionPageList.slice(
                      0,
                      QuestionPageList.filter(
                        (item) => item.leadsQuestions?.required == 1,
                      ).length,
                    ).filter(
                      (item) =>
                        item.selectedCodes == null ||
                        item.selectedCodes.length == 0,
                    ).length > 0
                  "
                  @click="Savemyanswers"
                >
                  Save My Answer
                </button>
                <!-- <button class=" btn_exportyellow riskButton"
                                style="background-color: #E7E5FF;color:#8E86DD;margin-right: 20px;"
                                @click="questionWentiDialog = false">
                                Cancel
                            </button> -->
                <button
                  :disabled="
                    QuestionPageList.slice(
                      0,
                      QuestionPageList.filter(
                        (item) => item.leadsQuestions?.required == 1,
                      ).length,
                    ).filter(
                      (item) =>
                        item.selectedCodes == null ||
                        item.selectedCodes.length == 0,
                    ).length > 0
                  "
                  class="btn_exportyellow riskButton"
                  @click="ShowResult(false)"
                >
                  Show Result
                </button>
              </div>
            </div>
          </div>
          <div class="Close-Icon" @click="CanclogQuetion">
            <i class="iconfont icon-cuowu icon"></i>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="questionDialog"
      center
      :close-on-click-modal="true"
      @close="closeDialog"
      custom-class="dialog_normal_question"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <h3>Your search criteria for customer acquisition</h3>
          <div class="question-detail_cont">
            <ul>
              <li
                class="question-detail_cont-list margin-bottom20"
                v-for="(item, index) in quesitonList"
                :key="index"
              >
                <p>{{ item.label }}</p>
                <h3>{{ item.value }}</h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="flex_center margin-top20">
        <button
          class="btn_exportyellow riskButton btn_dialog_condi"
          @click="Savemyanswers"
        >
          Save my answers
        </button>
        <div>
          <button
            class="btn_exportyellow riskButton btn_dialog_condi margin-left30"
            style="background-color: #e7e5ff; color: #8e86dd"
            @click="closeDialog"
          >
            Cancel
          </button>
          <button
            class="btn_exportyellow riskButton btn_dialog_condi margin-left30"
            @click="ShowResult(false)"
          >
            Show result
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="SaveDialog"
      center
      :close-on-click-modal="true"
      @close="closeSaveDialog"
      custom-class="dialog_normal_question"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <h3 v-if="$parent.isNewQuestion" class="dialog_normal_question-head">
            Do you like to save your current selections of search criteria?
          </h3>

          <h3 v-else class="dialog_normal_question-head">
            Please name your condition
          </h3>
          <div class="SaveDialog_input">
            <el-input
              id="ceb3e3"
              v-model="templateName"
              placeholder="Please enter the template name"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="  " style="display: flex; justify-content: center">
        <div>
          <button
            class="btn_exportyellow riskButton btn_dialog_condi"
            style="background-color: #e7e5ff; color: #8e86dd"
            @click="closeSaveDialog"
          >
            {{ $t("MyAccount.Cancel") }}
          </button>
          <button
            v-if="$parent.isNewQuestion"
            class="btn_exportyellow riskButton margin-left30 btn_dialog_condi"
            @click="Nosave()"
          >
            No Save
          </button>

          <button
            :disabled="templateName.length == 0"
            class="btn_exportyellow riskButton btn_dialog_condi margin-left30"
            @click="SaveInputName()"
          >
            Confirm
          </button>
        </div>
      </div>
    </el-dialog>
    <SearchLeads
      v-if="SearchLeadsSuo && !questionWentiDialog"
      :suoClose="SearchLeadsSuo"
      @closeCloseDialog="clossuoDialog($event)"
    ></SearchLeads>
  </div>
</template>
<script>
import _ from "lodash";
import { mixins1 } from "@/mixins/index";
import SearchLeads from "../SearchLeads.vue";
import { searchCompany } from "@/api/searchApi.js";
import { saveLeadsPostFilter } from "@/api/companyApi.js";
import {
  saveLeadsAnswers,
  getLeadsQuestions,
  getLeadsProductFilterList,
  getIndustryCodeFilterList,
  updateLeadsAnswersHead,
} from "@/api/userApi";
import { jwtDecode } from "jwt-decode";
import { json } from "d3";

export default {
  mixins: [mixins1],
  components: {
    SearchLeads,
  },

  name: "",
  props: {
    CompanyQuestionShow: {
      type: Boolean,
    },
  },

  watch: {
    "$store.state.app.leadesTags": {
      handler(newVal, oldVal) {
        this.SavedAnswersList = newVal;
        // 在这里处理columns属性的变化
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },

    CompanyQuestionShow: {
      handler(newVal, oldVal) {
        if (newVal) {
          // console.log(`questionWentiDialog`,questionWentiDialog );
          // this.$parent.token
          if (true) {
            //    this.questionWentiDialog=newVal

            this.getListsaveLeadsAnswers();
            this.showInptIndustry = true;
            this.NewShowIndex = 0;
            this.setToolsAciveFalse();
          }
        }

        // 在这里处理Sort属性的变化
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  created() {},
  mounted() {
    this.setToolsAciveFalse();
    this.$store.dispatch("app/setThemColor", "#8E86DD");
    this.$store.dispatch("app/setSearchType", "risk");
  },
  data() {
    return {
      ProductIndustryList: [],
      cascInptIndustry: "",
      showInptIndustry: true,
      trigger: "manual",
      SaveDialog: false,
      questionWentiDialog: false,
      statesCountryarr: "",
      questionDialog: false,
      objectTypeValue: [],
      activeNames: ["0"],
      templateName: this.$store.state.app.SeachLabelsCodeName,
      QuestionPageList: [],
      QuestionPageListON: [],
      arrSearch: [],
      objectTypeoptions: [],
      statesCountry: [],
      SearchLeadsSuo: true,
      quesitonList: [],
      CompanyCountryoptions: [],
      isCpc: true,
      Companyoptions: [],
      Companyvalue: ["APPLE", "COLFAX CORPORATION"],
      competitorsCompanyvalue: ["APPLE", "COLFAX CORPORATION", "HUAWEI"],
      CompanyCountryvalue: ["China"],
      list: [],
      loading: true,
      QuestionLoding: false,
      states: [],
      currentIndex: 0,
      index: -1,
      percentage: 34,
      carouselItems: ["", "", "", "", "", ""],
      roleQuestion: [],
      targetingradio: "1",
      SavedAnswerIndexActive: undefined,
      checkList: [],
      SavedAnswersList: [],
      cascaderProps: {
        // 这里设置最后一层可以多选
        multiple: false,
        checkStrictly: false, // 允许选择不严格
        emitPath: false, // 不发出路径
        label: "optionsContent", // 显示的标签
        value: "id", // 选中的值
        children: "list",
        // 其他属性可以根据需要添加
      },
      cascaderPropsProduct: {
        multiple: false,
        checkStrictly: false, // 允许选择不严格
        emitPath: false, // 不发出路径
        label: "optionsContent", // 显示的标签
        value: "id", // 选中的值
        children: "list",
      },
      urposeValue: "",
      qualificationsValue: "",
      audienceValue: "",
      lengthValue: "",
      enterpriseValue: "",
      creditValue: "",
      selectValue: "",
      sizeValue: "",
      resquestion: {},
      keyword: "",
      NewShowIndex: 0,
    };
  },

  methods: {
    CanclogQuetion() {
      this.questionWentiDialog = false;
      this.SearchLeadsSuo = true;
      this.NewShowIndex = 0;
      this.getListsaveLeadsAnswers();
    },
    setToolsAciveFalse() {
      this.$store.dispatch("app/setTools", {
        name: "Optimize",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false && this.$parent.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false && this.$parent.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });

      //   this.$store.dispatch("app/setTools", "filter",'isActive',false);
    },
    ActiceNewIndex(index) {
      let indexTrue = !(
        this.QuestionPageList.slice(
          0,
          this.QuestionPageList.filter(
            (item) => item.leadsQuestions?.pageNo <= 1,
          ).length,
        ).filter(
          (item) =>
            item.selectedCodes == null || item.selectedCodes.length == 0,
        ).length > 0
      );

      if (indexTrue && index == 1) {
        this.NewShowIndex = index;
      }
      let indexTrueTwo = !(
        this.QuestionPageList.slice(
          0,
          this.QuestionPageList.filter(
            (item) => item.leadsQuestions?.pageNo <= 2,
          ).length,
        ).filter(
          (item) =>
            item.selectedCodes == null || item.selectedCodes.length == 0,
        ).length > 0
      );

      if (indexTrueTwo && index == 2) {
        this.NewShowIndex = index;
      }
      let indexTrueTree = !(
        this.QuestionPageList.slice(
          0,
          this.QuestionPageList.filter(
            (item) => item.leadsQuestions?.pageNo <= 3,
          ).length,
        ).filter(
          (item) =>
            item.selectedCodes == null || item.selectedCodes.length == 0,
        ).length > 0
      );

      if (indexTrueTree && index == 3) {
        this.NewShowIndex = index;
      }
      if (this.NewShowIndex > index) {
        this.NewShowIndex = index;
      }
    },
    handleactiveNamesChange(val) {
      if (this.$parent.PCMoudele[3].hasPrivilege) {
        this.activeNames = val;
      } else {
        this.activeNames = ["0"];
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
      //
      //
    },
    highlightKeyword(text) {
      if (!this.keyword) {
        return text;
      }
      const regex = new RegExp(this.keyword, "gi");
      return text.replace(
        regex,
        (match) => `<span class="highlight">${match}</span>`,
      );
    },
    clossuoDialog(value) {
      this.questionWentiDialog = true;
      this.SearchLeadsSuo = value;
    },
    cascaderflase() {
      // this.$refs.cascader[0].dropDownVisible=false
    },
    clickOutSide() {
      // this.$refs.cascader[0].dropDownVisible=false

      //
      if (this.$refs.upSelectwo) {
        this.$refs.upSelectwo.forEach((item) => {
          item.visible = false;
        });
      }
      if (this.$refs.upSelectduoxuanSearch) {
        this.$refs.upSelectduoxuanSearch.forEach((item) => {
          item.visible = false;
        });
      }
      if (this.$refs.upSelect) {
        this.$refs.upSelect[0].visible = false;
      }
      if (this.$refs.upSelectduoxuan) {
        this.$refs.upSelectduoxuan[0].visible = false;
      }
    },
    clickOutSideTwo(index) {},

    Finish() {
      this.quesitonList = [];
      this.questionDialog = true;
      this.QuestionPageList.forEach((item, index) => {
        if (item.selectedCodes != null) {
          if (Array.isArray(item.selectedCodes)) {
            if (item.selectedCodes.length > 0) {
              if (item.leadsQuestions.type == 9) {
                this.quesitonList.push({
                  value: item.selectedCodes
                    .map((item) => {
                      return item.optionsContent;
                    })
                    .join(","),
                  label: item.leadsQuestions.questionContent,
                });
              } else {
                this.quesitonList.push({
                  value:
                    item.leadsQuestions.type == 7 ||
                    item.leadsQuestions.type == 5
                      ? item.selectedCodes
                      : item.selectedCodes
                          .map((item) => {
                            return item.optionsContent;
                          })
                          .join(","),
                  label: item.leadsQuestions.questionContent,
                });
              }
            }
          } else {
            this.quesitonList.push({
              value:
                item.leadsQuestions.type == 7 || item.leadsQuestions.type == 5
                  ? item.selectedCodes
                  : item.selectedCodes.optionsContent,
              label: item.leadsQuestions.questionContent,
            });
          }
        }

        // else {

        //     if (item.selectedCodes != null) {
        //         this.quesitonList.push({
        //             value: item.selectedCodes[0].optionsContent,
        //             label: item.selectedCodes.questionContent,
        //         })
        //     }
        // }
      });
    },

    leadsQuestionschange(value) {
      if (value.optionsType == 1) {
        this.QuestionPageList.map((item, index) => {
          if (index > 0) {
            item.selectedCodes = null;
            item.selectedOptions = null;
          }
        });
      }

      let arrQusetion = this.QuestionPageList.map((item) => {
        return {
          ...item,
          selectedOptions:
            item.selectedCodes == null
              ? null
              : JSON.stringify(item.selectedCodes),
        };
      });
      getLeadsQuestions({
        leadsAnswersHead: {
          id: null,
          userId: null,
          title: null,
          creatTime: null,
          updateTime: null,
        },
        leadsQuestionsVOList: arrQusetion,
      }).then((res) => {
        this.QuestionPageList = [];

        if (res.code == 200) {
          this.QuestionPageList = res.data.leadsQuestionsVOList;

          this.QuestionPageList.map((item, index) => {
            item.selectedCodes =
              item.selectedCodes == null
                ? JSON.parse(item.selectedCodes)
                : item.selectedCodes;
            item.showCode =
              item.selectedCodes == null ? null : item.selectedCodes.id;
          });
        }
        console.log(this.NewShowIndex);

        if (this.QuestionPageList.length > 3 && this.$route.query.aaa_id) {
          let index = this.QuestionPageList.findIndex(
            (item) =>
              item.leadsQuestions.type == 9 && item.leadsQuestions.code == 6,
          );
          console.log(index);
          let seachCompanyList = [
            {
              optionsCode: this.$route.query.aaa_id,
              optionsContent: this.$route.query.name_en,
              flag: this.$route.query.country_code,
              aaa_id: this.$route.query.aaa_id,
            },
          ];
          let countryImg = this.getCountryImgUrl(
            this.$route.query.country_code,
          );
          let flag = require("../../../../../static" + countryImg);
          seachCompanyList[0].flag = flag;

          this.QuestionPageList[index].leadsOptions = seachCompanyList;
          // this.QuestionPageList[index].selectedCodes=seachCompanyList[0]
          // console.log('  this.QuestionPageList[index].leadsOptions',seachCompanyList[0]);
          // console.log(  this.QuestionPageList[index].selectedCodes);

          // this.QuestionPageList[index].selectedCodes=seachCompanyList[0]
        }
      });
    },
    cleanEmptyLists(options) {
      return options.map((option) => {
        // 递归清理子选项
        const cleanedChildren = this.cleanEmptyLists(option.list);
        // 只保留非空的子选项，若为空则置为 null
        return {
          ...option,
          list: cleanedChildren.length > 0 ? cleanedChildren : null, // 修改这里
        };
      });
      // .filter(option => option.list !== null); // 只保留 list 不为 null 的选项
    },
    getListsaveLeadsAnswers() {
      getLeadsQuestions({}).then((res) => {
        if (res.code == 200) {
          this.resquestion = res;
          this.QuestionPageList = res.data.leadsQuestionsVOList;
          this.QuestionPageListON = res.data.leadsQuestionsVOList;
          this.QuestionPageList.map((item) => {
            item.showCode = null;
          });

          // this.QuestionPageList[0].leadsOptions.forEach(item=>{
          //    if( item.list.length>0){
          //     item.list.forEach(ite=>{
          //         ite.list=null
          //     })
          //    }
          // })
        }
      });
    },
    // ShowResult自己展示
    ShowResult() {
      if (this.$parent.token) {
        this.$parent.isNewQuestion = true;
        this.questionWentiDialog = false;
        this.$parent.CompanyQuestionShow = false;
        this.questionDialog = false;
        this.$parent.setToolsAcive();
        this.$emit("getPantentList", this.QuestionPageList);
      } else {
        this.$parent.$parent.$parent.loginDialog = true;
      }

      // this.SaveDialog = false
    },

    //    输入保存问题
    SaveInputName() {
      if (this.$parent.SaveAnswer && this.$store.state.app.SeachLabels != "") {
        //    console.log(`this.$parent.ComanyFilterList`, this.$parent.ComanyFilterList);
        let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
        let arrFileter = this.$parent.ComanyFilterList.map((item, index) => {
          if (
            Array.isArray(item.selectedCodes) &&
            item.selectedCodes.length > 0
          ) {
            item.selectedOptions = item.leadsOptions.filter((ite) => {
              return ite.optionsCode == item.selectedCodes[0];
            });
          }
          return { ...item };
        });
        // console.log(`arrFileter`, arrFileter);
        arrFileter.map((item) => {
          item.selectedOptions =
            item.selectedOptions == null || item.selectedCodes.length == 0
              ? null
              : JSON.stringify(item.selectedOptions[0]);
        });

        saveLeadsPostFilter({
          leadsAnswersHead: {
            id: this.$store.state.app.SeachLabels,
            userId: userinfo.id,
            title: this.templateName,
            creatTime: null,
            updateTime: null,
          },
          leadsQuestionsVOList: arrFileter,
        }).then((res) => {});
        updateLeadsAnswersHead({
          leadsAnswersHead: {
            id: this.$store.state.app.SeachLabels,
            userId: userinfo.id,
            title: this.templateName,
            creatTime: null,
            updateTime: null,
          },
        }).then((res) => {
          if (res.code == 200) {
            this.SaveDialog = false;
            this.$parent.$parent.$parent.getCommonPrivilegeModule();
            this.$message({
              message: res.msg,
              center: true,
              type: "success",
            });
            this.$emit("refreshCompanyList", this.templateName);
          } else {
            this.$message({
              message: res.msg,
              center: true,
              type: "error",
            });
          }
        });
      } else {
        let arrQusetion = this.QuestionPageList.map((item, index) => {
          if (Array.isArray(item.selectedCodes)) {
            if (item.selectedCodes?.length > 0) {
              item.selectedCodes.map((ite) => {
                ite.list = null;
              });
            } else {
              item.selectedCodes = null;
            }
          }
          return {
            ...item,
            selectedOptions:
              item.selectedCodes == null
                ? null
                : JSON.stringify(item.selectedCodes),
            selectedCodes: item.selectedCodes,
          };
        });

        let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
        saveLeadsAnswers({
          leadsAnswersHead: {
            id: null,
            userId: userinfo.id,
            title: this.templateName,
            creatTime: null,
            updateTime: null,
          },
          leadsQuestionsVOList: arrQusetion,
        }).then((res) => {
          if (res.code == 200) {
            this.$parent.$parent.$parent.getCommonPrivilegeModule();

            this.$store.dispatch(
              "app/SetSeachLabels",
              res.data.leadsAnswersHead.id,
            );
            this.$store.dispatch(
              "app/SetSeachLabelsCodeName",
              res.data.leadsAnswersHead.title,
            );
            this.questionWentiDialog = false;
            this.$parent.CompanyQuestionShow = false;
            this.questionDialog = false;
            this.SaveDialog = false;
            this.$parent.isNewQuestion = false;

            // this.$store.commit("setRefreshKey", new Date().getTime());
          } else {
            this.$parent.isNewQuestion = true;
            this.$message({
              message: res.msg,
              center: true,
              type: "error",
            });
          }
        });

        // this.ShowResult()
      }
    },
    // 保存问题弹框
    Savemyanswers() {
      if (this.$parent.token) {
        if (this.$parent.PCMoudele[5].hasPrivilege) {
          this.$parent.isNewQuestion = false;
          this.SaveDialog = true;
        } else {
          this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
        }
      } else {
        this.$parent.$parent.$parent.loginDialog = true;
      }

      // if(this.$parent.PCMoudele){

      // }
      //
    },
    // 关闭保存弹框
    closeSaveDialog() {
      this.SaveDialog = false;
      this.$parent.RiskLoding = false;
    },
    Nosave() {
      this.SaveDialog = false;
      this.$parent.isNewQuestion = false;
    },
    //关闭弹框
    closeDialog() {
      this.questionDialog = false;
    },
    goToNextSlide1() {
      this.percentage = this.percentage - 33;
      this.$refs.carousel.prev();
    },
    // 模糊 搜索
    competitorsremoteMethod(query) {
      if (query !== "") {
        this.loading = false;
        this.Companyoptions = this.states.filter((item) => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.Companyoptions = [];
      }
    },

    // 公司名称模糊搜索
    debouncedRemoteMethodCompany: _.debounce(function (query) {
      this.loading = false;
      this.remoteMethodSeachCompany(query, 6);
    }, 1000), // 300毫秒延迟
    debouncedRemoteMethodCompany3: _.debounce(function (query) {
      this.loading = false;
      this.remoteMethodSeachCompany(query, 7);
    }, 1000), // 300毫秒延迟
    async remoteMethodSeachCompany(query, page) {
      if (query !== "") {
        this.loading = true;
        this.keyword = query;

        let params = {
          company_name: query,
          page: 1,
          pageSize: 100,
        };
        //    'company_name=' + this.searchName + '&company_country=' + this.searchCode + '&page=' + this.page.pageNo + '&pageSize=' + this.page.pageSize + '&province_en=' + this.province + '&city_en=' + this.city + '&isic_code=' + this.industryCheck + '&company_class_code=' + this.companyTypeCheck + '&searchType=' + this.keywords + '&scale_code=' + this.companySizeCheck + '&reg_status=' + this.companyStatusCheck + '&listing_status_code=' + this.listedCompanyCheck + '&years=' + this.timePeriodCheck
        let res = await searchCompany(params);

        let parentTable = [];
        if (res.code == 200) {
          setTimeout(() => {
            let list = (parentTable = res.data.rows);

            //查找本地图片
            list = list.map((item, index) => {
              let countryImg = this.getCountryImgUrl(item.company_country);
              if (countryImg) {
                let flag = require("../../../../../static" + countryImg);
                parentTable[index].flag = flag;
              }
            });
            let index = this.QuestionPageList.findIndex(
              (item) =>
                item.leadsQuestions.type == 9 &&
                item.leadsQuestions.code == page,
            );
            let seachCompanyList = [];
            seachCompanyList = parentTable.map((item) => {
              return {
                optionsCode: item.aaa_id,
                optionsContent: item.company_name_en
                  ? item.company_name_en
                  : item.company_name,
                flag: item.flag,
                aaa_id: item.aaa_id,
              };
            });
            this.QuestionPageList[index].leadsOptions = seachCompanyList;

            this.loading = false;
          }, 10);
        } else {
          // this.addPopIndex2=true
          if (res.code == "1002") {
            this.$message({
              message: res.msg,
              center: true,
              type: "error",
            });
          } else {
            this.loading = false;
            // this.parentTable = [];
          }
        }
      } else {
        // this.loading = false;
        this.Companyoptions = [];
      }
    },
    debouncedRemoteMethodfocus(query) {
      // console.log(`query`, query);
      // this.$refs.upSelectProductSearch[0].visible=false
    },
    debouncedRemoteMethod: _.debounce(function (query) {
      this.remoteMethod(query, 3);
    }, 300), // 300毫秒延迟
    debouncedRemoteMethod3: _.debounce(function (query) {
      this.remoteMethod(query, 12);
    }, 300),
    debouncedRemoteMethodgetProductList: _.debounce(function (query) {
      this.getProductList(query);
    }, 800),
    // 模糊 搜索
    remoteMethod(query, page) {
      if (query !== "") {
        this.keyword = query;
        this.loading = true;
        let industryCode = [
          "FI1001",
          "IF1001",
          "GM1001",
          "GM1003",
          "SC1001",
          "SC1003",
          "ID1001",
          "ID1003",
        ];
        if (
          industryCode.includes(
            this.QuestionPageList[1].selectedCodes.optionsCode,
          )
        ) {
          getIndustryCodeFilterList({
            optionsContent: query,
          }).then((res) => {
            if (res.code == 200) {
              setTimeout(() => {
                this.loading = false;

                let index = this.QuestionPageList.findIndex(
                  (item) => item.leadsQuestions.type == 8,
                );
                this.QuestionPageList[index].leadsOptions = res.data;
              }, 10);
            } else {
              this.Companyoptions = [];
            }
          });
        } else {
          getLeadsProductFilterList({
            // isicCode: this.QuestionPageList[0].selectedCodes.optionsCode,
            productNameDesc: query,
            pageSize: 50,
          }).then((res) => {
            if (res.code == 200) {
              setTimeout(() => {
                this.loading = false;

                let index = this.QuestionPageList.findIndex(
                  (item) => item.leadsQuestions.type == 8,
                );
                this.QuestionPageList[index].leadsOptions = res.data;
              }, 10);
            } else {
              this.Companyoptions = [];
            }
          });
        }
      } else {
        // ;
      }
    },
    menuCheck(value) {
      if (value) {
        this.showInptIndustry = false;
        this.cascInptIndustry = "";
        this.QuestionPageList[2].leadsOptions.forEach((item) => {
          item.list.forEach((ite) => {
            if (ite.id == value) {
              this.QuestionPageList[2].selectedCodes = ite;
            }
          });
        });
      } else {
        this.showInptIndustry = true;
      }
    },
    getProductList() {
      if (this.cascInptIndustry !== "") {
        this.keyword = this.cascInptIndustry;
        this.loading = true;

        getLeadsProductFilterList({
          // isicCode: this.QuestionPageList[0].selectedCodes.optionsCode,
          productNameDesc: this.cascInptIndustry,
          pageSize: 100,
        }).then((res) => {
          if (res.code == 200) {
            setTimeout(() => {
              this.loading = false;

              let index = this.QuestionPageList.findIndex(
                (item) => item.leadsQuestions.type == 8,
              );
              this.QuestionPageList[index].leadsOptions = res.data;
            }, 10);
            this.$nextTick(() => {
              this.$refs.IndustryProduct[0].dropDownVisible = true;
            });
          } else {
            this.Companyoptions = [];
          }
        });
      } else {
        // ;
      }
    },
    // 模糊 搜索国家
    remoteMethodCountry(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.CompanyCountryoptions = this.statesCountry.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.CompanyCountryoptions = [];
      }
    },
    // 左侧如果有保存条件
    SavedAnswerIndex(item, index) {
      this.SavedAnswerIndexActive = index;
      this.currentIndex = 0;
      this.percentage = 34;
      this.$nextTick(() => {
        this.$refs.carousel.setActiveItem(0);
      });

      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;

      getLeadsQuestions({
        leadsAnswersHead: {
          id: item.id,
          userId: userinfo.id,
          title: null,
          creatTime: null,
          updateTime: null,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.QuestionPageList = res.data.leadsQuestionsVOList;

          this.QuestionPageList.map((item, index) => {
            item.selectedCodes = JSON.parse(item.selectedOptions);
            if (item.leadsQuestions.type == 9) {
              item.leadsOptions = item.selectedCodes;
            }
            if (index == 0) {
              item.showCode = Number(item.selectedCodes.id);
            }
          });

          // this.CompanyQuestionList = res.data.leadsQuestionsVOList.filter(
          //     (item) => item.selectedOptions != null
          // );
          // this.CompanyQuestionList.map((item, index) => {
          //     item.selectedCodes = JSON.parse(item.selectedOptions);
          //     if (index == 0) {
          //         item.showCode = Number(item.selectedCodes.id);
          //     }
          // });
        }
      });
    },
    handleChange(value) {
      let arr = null;
      this.QuestionPageList[0].leadsOptions.forEach((item) => {
        item.list.forEach((ite) => {
          if (ite.list != null) {
            ite.list.forEach((it) => {
              if (it.id == value) {
                arr = it;
              }
            });
          }
        });
      });
      this.QuestionPageList[0].selectedOptions = JSON.stringify(arr);
      this.QuestionPageList[0].selectedCodes = JSON.stringify(arr);
      let arrQusetion = this.QuestionPageList;
      // this.QuestionPageList[1].selectedCodes = []

      getLeadsQuestions({
        leadsAnswersHead: {
          id: null,
          userId: null,
          title: null,
          creatTime: null,
          updateTime: null,
        },
        leadsQuestionsVOList: arrQusetion,
      }).then((res) => {
        if (res.code == 200) {
          this.QuestionPageList = res.data.leadsQuestionsVOList;

          this.QuestionPageList.map((item, index) => {
            item.selectedCodes = JSON.parse(item.selectedCodes);
            item.showCode =
              item.selectedCodes == null ? null : item.selectedCodes.id;
          });
        }
      });
    },
    handleChangetwo(value) {
      let index = this.QuestionPageList.findIndex(
        (item) => item.leadsQuestions.id == 11,
      );
      let arr = null;
      this.QuestionPageList[index].leadsOptions.forEach((item) => {
        item.list.forEach((ite) => {
          if (ite.list != null) {
            ite.list.forEach((it) => {
              if (it.id == value) {
                arr = it;
              }
            });
          }
        });
      });
      this.QuestionPageList[index].selectedOptions = JSON.stringify(arr);
      this.QuestionPageList[index].selectedCodes = arr;
    },
    handleCarouselChange(index) {
      this.currentIndex = index;
    },
    // 下一页
    goToNextSlide(index) {
      if (index == 0) {
        let arrQusetion = this.QuestionPageList.map((item) => {
          return {
            ...item,
            selectedOptions:
              item.selectedCodes == null
                ? null
                : JSON.stringify(item.selectedCodes),
          };
        });

        getLeadsQuestions({
          leadsAnswersHead: {
            id: null,
            userId: null,
            title: null,
            creatTime: null,
            updateTime: null,
          },
          leadsQuestionsVOList: arrQusetion,
        }).then((res) => {
          if (res.code == 200) {
            this.QuestionPageList = res.data.leadsQuestionsVOList;

            this.QuestionPageList.map((item, index) => {
              if (item.leadsQuestions.id == 5 && item.selectedOptions == null) {
                item.selectedCodes = [];
              }
              if (
                item.leadsQuestions.type == 8 &&
                item.selectedOptions != null
              ) {
                item.leadsOptions = [item.selectedCodes];
              }
              item.showCode =
                item.selectedCodes == null ? null : item.selectedCodes.id;
            });
          }
        });
      }
      if (index === this.currentIndex) {
        this.percentage = this.percentage + 33;
        this.$refs.carousel.next();
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
.height_100 {
  height: 100%;
}

.p10 {
  padding: 10px;
}

.leads-content {
  position: relative;
  z-index: 990;
  background: #f5f5f5;
  border-radius: 6px;
  min-height: 60vh;
}

.leads-flex {
  display: flex;
  height: 100%;
  /* overflow-y:scroll ; */
}

.leads-content-right {
  flex: 1;
  /* overflow: hidden; */
  /* height: 225%; */
  background: #f5f5f5;
  border-radius: 6px;
  text-align: center;
  /* overflow-y: auto; */
}

.leads-content-right-content {
  /* width: 58%; */
  margin: 0 auto;
  text-align: center;
  height: 100%;
}

.question-step-question {
  font-size: 26px;
  color: #1a2332;
  line-height: 32px;
  font-family: "Arial Bold";
  text-align: left;
  word-break: keep-all;
}

.question-step-con {
  margin-bottom: 0;
}

.bitian {
  color: #f56b6b;
  font-size: 18px;
  margin-right: 5px;
}

.btn_dialog_condi,
.btn_exportyellow {
  background: #8e86dd;
  color: #fff;
  padding: 0 10px;
}

.btn_exportyellow {
  min-width: 240px;
  font-family: "Arial";
}

.btn_dialog_condi {
  min-width: 210px;
  font-family: "Arial Bold";
}

.question_bottom .btn_exportyellow {
  color: #fff;
}

.leads-content-right /deep/ .el-cascader {
  width: 100%;
}

.leads-content-right /deep/ .el-carousel__container {
  height: 100%;
}

.leads-content-right /deep/ .el-progress__text {
  display: none;
}

.leads-content-right /deep/ .el-collapse-item__header {
  height: auto;
  line-height: normal;
  border: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #8e86dd !important;
  background-color: #f5f5f5;
  margin-bottom: 20px;
}

.leads-content-right /deep/ .el-collapse-hade:hover {
  text-decoration: underline;
}

.leads-content-right /deep/ .el-collapse {
  border: none;
}

.leads-content-right /deep/.el-carousel--horizontal {
  height: 100%;
}

.leads-content-right /deep/ .el-collapse-item__arrow {
  color: #f5f5f5;
}

.leads-content-right /deep/ .el-radio.is-bordered {
  background: #ffffff;
  border-radius: 10px;
}

.leads-content-right /deep/.el-radio.is-bordered {
  width: 49%;
  height: 62px;
  justify-content: flex-start;
  margin-right: 0;
  padding: 0;
  padding-left: 20px;
  border: 1px solid #ccc;
}

::v-deep .is-bordered {
  border: 1px solid #cccccc !important;
}

.leads-content-right /deep/ .el-radio.is-bordered.is-checked {
  border: 1px solid #8e86dd !important;
}

.leads-content-right /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #8e86dd;
}

.leads-content-right
  /deep/
  .el-radio__input.is-checked
  .el-radio__inner::after {
  background: #8e86dd;
}

.leads-content-right /deep/ .el-radio__label {
  font-size: 20px;
  color: #1a2332;
  display: flex;
  align-items: center;
}

.leads-content-right /deep/ .el-collapse-item__content {
  padding-bottom: 0;
}

.leads-content-right /deep/ .el-tag.el-tag--info .el-tag__close {
  color: #ffffff;
  background-color: #f56b6b;
}

.leads-content-right /deep/ .el-tag.el-tag--info {
  height: 40px;
  background: #ffffff;
  border-radius: 23px;
  border: 1px solid #cccccc;
  font-size: 18px;
  color: #1a2332;
  margin: 5px 10px 5px 0;
}

.-dropdown__item {
  font-size: 1.2857142857142858rem !important;
  color: #1a2332;
  /* line-height: 35px !important; */
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-bottom: 5px;
  white-space: normal;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #8e86dd !important;
}

.question-detail_cont {
  height: 50vh;
  background: #f5f5f5;
  border-radius: 6px;
  overflow-y: auto;
  padding: 20px;
  margin-top: 20px;
}

.question-detail_cont-list p {
  font-size: 20px;
  color: #666666;
}

.detail_cont .question-detail_cont-list h3 {
  margin-top: 10px;
  font-size: 20px;
  color: #1a2332;
  text-align: left;
}

.SaveDialog_input {
  margin: 30px 0 30px 0;
}

.SaveDialog_input /deep/ .el-input__inner {
  height: 56px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #cccccc;
  font-size: 20px;
}

/deep/ .el-select-dropdown {
  left: 0px !important;
  width: 100%;
}

/deep/ .el-select-dropdown__item {
  height: auto !important;
  text-align: left;
  font-size: 18px !important;
}

/deep/ .el-popper {
  z-index: 99 !important;
}

/deep/ .el-cascader .el-input.is-focus .el-input__inner {
  border-color: #cccccc !important;
}

/deep/ .highlight {
  color: #f56c6c;
  font-weight: bold;
}

.Country_img {
  width: 24px;
  margin-right: 10px;
}

.Country_name {
  /* line-height: 1.6rem !important; */
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Search_Company {
  margin-bottom: 6px;
}

.question-step-con /deep/ .el-select__tags {
  padding-left: 20px;
}

/deep/ .el-collapse-item__wrap {
  background-color: #f5f5f5 !important;
}

button:disabled {
  cursor: no-drop !important;
  background-color: #eeeeee !important;
  color: #999999;
}

.el-saech-eye {
  position: absolute;
  right: 5px;
  top: 0px;
  color: #1a2332;
  font-size: 20px;
}

/deep/ .el-select__input {
  margin-left: 10px;
  font-size: 20px;
}

.ActiveCode {
  color: rgb(142, 134, 221);
}

.IndustryProvie {
  position: relative;
}

.IndustryProvie .cas_inpt {
  top: 0.514285rem;
  font-size: 1.4285714rem;
  width: 94%;
}

.newHuokequestion {
  width: 800px;
  height: 820px;
  background: #f5f5f5;
  padding: 40px 130px;
  position: relative;
  overflow: visible;
}

.newHuokequestion .leads-content-right {
  height: 100% !important;
  width: 100%;
}

.NewHuokeradio /deep/ .el-radio-group,
.NewHuokeradio,
.NewHuokeradio /deep/ .el-radio.is-bordered {
  width: 100% !important;
}

.NewHuokeradio /deep/ .el-radio.is-bordered + .el-radio.is-bordered,
.NewHuokeradio /deep/ .el-radio.is-bordered {
  margin-left: 0px !important;
  margin-bottom: 14px;
}

.NewHuokeradio /deep/ .el-radio.is-bordered:last-child {
  margin-bottom: 0 !important;
}

.NewHuokeradio /deep/ .el-radio__input {
  display: none !important;
}

.ActiveRedio {
  border: 1px solid #8e86dd !important;
}

.ActiveRedio /deep/ .el-radio__label {
  color: #1a2332 !important;
  font-family: "Arial Bold";
}

.newHouke-li {
  width: 60px;
  height: 6px;
  background: #dddddd;
  border-radius: 5px;
  margin-right: 8px;
}

.newHouke-ul {
  display: flex;
  justify-content: center;
}

.newShowActive {
  background: #8e86dd;
  cursor: pointer;
}

.postion_bottom {
}

.reaio-no /deep/ .el-radio__input {
  display: none;
}

.Close-Icon {
  position: absolute;
  right: 30px;
  top: 30px;
}

.Close-Icon .icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
}

::v-deep .el-collapse-item__content {
  min-height: 26rem;
}

.leads_search_box {
  height: 100%;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: center;
  border-radius: 4px;
}

.leads_search {
  height: 100%;
  background: #ffffff;
}

.newHuo_left {
  position: relative;
  width: 500px;
}

.leads-content-right-content /deep/ .el-input__inner {
  border-radius: 10px;
  font-size: 20px;
  padding-left: 20px;
  height: 50px;
}

.wrap-placeholder-select {
  position: relative;
  display: block;
}

.wrap-placeholder-select.is-empty::after {
  content: attr(data-placeholder);
  position: absolute;
  left: 20px;
  right: 44px;
  top: 12px;
  display: block;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  white-space: normal;
  word-break: break-word;
  color: #c0c4cc;
  pointer-events: none;
  z-index: 2;
}

.wrap-placeholder-select.is-empty:focus-within::after {
  opacity: 0;
}

.wrap-placeholder-select /deep/ .el-input__inner {
  height: 64px;
  line-height: 22px;
  padding: 12px 40px 12px 20px;
}

.leads-content-right-content /deep/ .el-textarea__inner {
  border-radius: 10px;
  font-size: 20px;
  padding: 12px 20px;
  line-height: 24px;
  resize: none;
}

::v-deep .question_step_box {
  width: 500px;
  height: 606px;
  padding: 0 5px;
  overflow-y: auto;
  margin-bottom: 30px;
}

.dialog_normal_question-head {
  margin: 0;
}

@media screen and (max-width: 1920px) {
  .newHuokequestion {
    width: 586px;
    height: 630px;
    border-radius: 22px;
    padding: 30px 100px;
    overflow: visible;
  }

  .NewHuokeradio /deep/ .el-radio.is-bordered + .el-radio.is-bordered,
  .NewHuokeradio /deep/ .el-radio.is-bordered {
    margin-bottom: 10px;
  }

  .Close-Icon {
    position: absolute;
    right: 16px;
    top: 16px;
  }

  ::v-deep .el-select__input {
    margin-left: 7px;
    font-size: 18px;
  }

  .question-step-question {
    font-size: 20px;
    line-height: 24px;
  }

  .leads-content-right /deep/ .el-radio.is-bordered {
    border-radius: 7px;
  }

  .leads-content-right /deep/.el-radio.is-bordered {
    height: 48px;
    padding-left: 15px;
  }

  .leads-content-right /deep/ .el-radio__label {
    font-size: 16px;
  }

  .Close-Icon .icon {
    width: 22px;
    height: 22px;
  }

  .Close-Icon .icon {
    width: 22px;
    height: 22px;
    font-size: 20px;
  }

  .question-step-con /deep/ .el-select__tags {
    padding-left: 15px;
  }

  .question-step-con {
    margin-bottom: 0;
  }

  .leads-content-right /deep/ .el-tag.el-tag--info {
    height: 32px;
    border-radius: 18px;
    font-size: 16px;
    margin: 4px 7px 3px 0;
  }

  .el-saech-eye {
    font-size: 18px;
  }

  .leads-content-right-content /deep/.el-input__inner {
    border-radius: 7px;
    font-size: 16px;
    padding-left: 15px;
    height: 45px;
  }

  .wrap-placeholder-select.is-empty::after {
    left: 15px;
    right: 40px;
    top: 10px;
    font-size: 14px;
    line-height: 18px;
    text-align: left;
  }

  .wrap-placeholder-select /deep/ .el-input__inner {
    height: 58px;
    line-height: 20px;
    padding: 10px 36px 10px 15px;
  }

  .leads-content-right-content /deep/ .el-textarea__inner {
    border-radius: 7px;
    font-size: 16px;
    padding: 10px 15px;
    line-height: 22px;
    resize: none;
  }

  .SaveDialog_input {
    margin: 22px 0 30px 0;
  }

  .SaveDialog_input /deep/ .el-input__inner {
    height: 45px;
    border-radius: 6px;
    font-size: 16px;
  }

  .btn_dialog_condi {
    min-width: 156px;
  }

  .leads-content-right /deep/ .el-collapse-item__header {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .p10 {
    padding: 7px;
  }

  .btn_exportyellow {
    min-width: 180px;
  }

  .btn_dialog_condi {
    min-width: 156px;
  }

  ::v-deep .el-select-dropdown__item {
    font-size: 16px !important;
    padding-right: 20px !important;
  }

  .Country_name {
    font-size: 16px;
  }

  .Country_img {
    margin-right: 7px;
  }

  .question-detail_cont {
    border-radius: 5px;
    padding: 15px;
    margin-top: 15px;
  }

  .question-detail_cont-list p {
    font-size: 16px !important;
  }

  .detail_cont .question-detail_cont-list h3 {
    margin-top: 7px;
    font-size: 16px;
  }

  .leads_search_box {
    border-radius: 22px;
  }

  .leads-content {
    min-height: 0;
  }

  .question_step_box {
    width: 380px;
    height: 470px;
    margin-bottom: 22px;
  }

  ::v-deep .el-collapse-item__content {
    min-height: 0;
  }
}

@media screen and (max-width: 1439px) {
  .newHuokequestion {
    width: 510px;
    height: 550px;
    padding: 26px 87px;
  }

  .question-step-question {
    font-size: 18px;
    line-height: 22px;
  }

  ::v-deep .el-select__input {
    margin-left: 5px;
    font-size: 14px;
  }

  .leads-content-right /deep/ .el-radio__label {
    font-size: 14px;
  }

  .leads-content-right /deep/ .el-radio.is-bordered {
    border-radius: 6px;
  }

  .leads-content-right /deep/.el-radio.is-bordered {
    height: 46px;
    padding-left: 12px;
  }

  .leads-content-right /deep/ .el-tag.el-tag--info {
    height: 30px;
    border-radius: 16px;
    font-size: 14px;
    margin: 3px 6px 3px 0;
  }

  .question-step-con /deep/ .el-select__tags {
    padding-left: 12px;
  }

  .el-saech-eye {
    font-size: 16px;
  }

  .leads-content-right-content /deep/ .el-input__inner {
    border-radius: 6px;
    font-size: 14px;
    padding-left: 12px;
    height: 40px;
  }

  .wrap-placeholder-select.is-empty::after {
    left: 15px;
    right: 40px;
    top: 10px;
    font-size: 14px;
    line-height: 18px;
    text-align: left;
  }

  .wrap-placeholder-select /deep/ .el-input__inner {
    height: 58px;
    line-height: 20px;
    padding: 10px 36px 10px 15px;
  }

  .leads-content-right-content /deep/ .el-textarea__inner {
    border-radius: 7px;
    font-size: 16px;
    padding: 10px 15px;
    line-height: 22px;
    resize: none;
  }

  .SaveDialog_input {
    margin: 20px 0 20px 0;
  }

  .SaveDialog_input /deep/ .el-input__inner {
    height: 40px;
    border-radius: 5px;
    font-size: 14px;
  }

  .btn_dialog_condi {
    min-width: 140px;
  }

  .leads-content-right /deep/ .el-collapse-item__header {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .p10 {
    padding: 6px;
  }

  .btn_exportyellow {
    min-width: 160px;
  }

  .btn_dialog_condi {
    min-width: 140px;
  }

  ::v-deep .el-select-dropdown__item {
    font-size: 14px !important;
    padding-right: 20px !important;
  }

  .Country_name {
    font-size: 14px;
  }

  .Country_img {
    margin-right: 6px;
  }

  .question-detail_cont {
    border-radius: 4px;
    padding: 12px;
    margin-top: 12px;
  }

  .question-detail_cont-list p {
    font-size: 14px;
  }

  .detail_cont .question-detail_cont-list h3 {
    margin-top: 6px;
    font-size: 14px !important;
  }

  .question_step_box {
    height: 406px;
    margin-bottom: 20px;
  }

  .Close-Icon {
    right: 36px;
    top: 36px;
  }
  ::v-deep .dialog_normal_question{
    width: 510px;
  }
}
</style>

<style>
.el-select-dropdown__empty,
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #f5f5f5;
  color: #8e86dd;
}

.el-select-dropdown__item {
  font-size: 20px !important;
}

.el-select-dropdown {
  width: 480px;
}

.el-select-dropdown__wrap {
  max-height: 296px;
}

@media screen and (max-width: 1920px) {
  .el-select-dropdown__item {
    font-size: 16px !important;
  }

  .el-select-dropdown {
    width: 370px;
  }

  .el-select-dropdown__wrap {
    max-height: 220px;
  }
}

@media screen and (max-width: 1439px) {
  .el-select-dropdown__item {
    font-size: 14px !important;
  }

  .el-select-dropdown {
    width: 330px;
  }

  .el-select-dropdown__wrap {
    max-height: 200px;
  }
}
</style>
